<template>

    <fragment>

        <div v-if="ispreview" class="notice-bar">
            <p>{{ language.preview_message }}</p>
        </div>

        <div
            v-on:mouseup="drop($event)"
            :class="ispreview ? 'is-preview-mode main-container' : 'main-container'"
        >
            <main-navigation
                :project="project"
                :geturl="computedGetUrl"
                :addurl="computedAddUrl"
                :addopinion="addopinion"
            />

            <slick :class="getClassMobile" ref="slick" :options="slickOptions">

                <div
                    v-for="(slide, index) in sortedProjectItems"
                    class="item-slide"
                    :class="`slide-item-${slide.id} ${slide.type}-type`"
                    :data-slideID="slide.id"
                    :key="`slide-${index}`"
                >

                    <!-- question types -->
                    <good-bad-slide
                        v-if="slide.question.type === 'goodbad'"
                        :ref="`goodbad-${slide.id}`"
                        :slide="slide"
                        :project="project"
                        :getPinImage="getPinImage"
                        :addopinion="addopinion"
                        :componentKey="componentKey"
                        :index="index"
                        :type="type"
                    />

                    <scale-freetext-slide
                        v-if="slide.question.type === 'scale' || slide.question.type === 'freetext'"
                        :slide="slide"
                        :project="project"
                        :addopinion="addopinion"
                        :index="index"
                    />
                    <!-- hint  -->
                    <div v-if="slide.question.type === 'goodbad' && ( dataStore.viewActive.normal || dataStore.viewActive.heatmap )" v-display-none="allowHint(project.slug, slide.id) ? true : false" id="hint">
                        
                        <p v-if="(slide.type == 'map' || slide.type == 'image')">

                            <span v-if="slide.hint">{{ slide.hint }}</span

                            ><span v-else>

                            {{ `
                                ${ slide.allow_bad_options && slide.allow_good_options ? language.hint_good_bad.replacePlaceholders({ type : language[ slide.type ] }) : '' }
                                ${ slide.allow_bad_options && ! slide.allow_good_options ? language.hint_bad.replacePlaceholders({ type : language[ slide.type ] }) : '' }
                                ${ ! slide.allow_bad_options && slide.allow_good_options ? language.hint_good.replacePlaceholders({ type : language[ slide.type ] }) : '' }
                            ` }}

                            </span
                            >
                        </p>
                        
                    </div>
                    <!-- zoom buttons  -->
                    <div
                        id="zoom-image"
                        v-if="
                            slide.type === 'image' &&
                                slide.question.type === 'goodbad' &&
                                (dataStore.viewActive.normal ||
                                    dataStore.viewActive.heatmap)
                        "
                    >
                        <button
                            title="Zooma in"
                            v-on:click="zoomInHandler(true)"
                            v-touch:tap="zoomInHandler(false)"
                        >
                            <i class="fas fa-plus"></i>
                        </button>

                        <button
                            title="Zooma ut"
                            v-on:click="zoomOutHandler(true)"
                            v-touch:tap="zoomOutHandler(false)"
                        >
                            <i class="fas fa-minus"></i>
                        </button>

                    </div>

                    <loading-screen v-if="loading" />

                </div>

            </slick>

            <skip-to-next />

            <div class="project-navigation" :class="{ addopinion : addopinion }">

                <div class="home-edit show-mobile">

                    <div v-if="!project.scheduled" class="d-flex align-items-center">

                        <a
                            v-if="addopinion"
                            class="btn btn-secondary"
                            :href="computedGetUrl"
                            :title="language.view_comments"
                        >
                            <img class="pin-navigation" alt="bra" src="/images/pin_bra.png" />
                        </a>

                        <a
                            v-if="!addopinion && project.welcome_mode !== 'END' && allowToSubmitCookie"
                            class="btn btn-secondary"
                            :href="computedAddUrl"
                            :title="language.give_comment"
                        >
                            <i class="fas fa-pencil-alt"></i>
                        </a>

                    </div>

                </div>

                <div class="home-edit show-desktop">

                    <div class="container">

                        <div v-if="!project.scheduled" class="d-flex align-items-center">

                            <a
                                v-if="addopinion"
                                class="btn btn-secondary flex"
                                :href="computedGetUrl"
                                :title="language.view_comments"
                            >
                                <img alt="bra" src="/images/pin_bra.png" /> {{ buttonname }}
                            </a>

                            <a
                                v-if="!addopinion && project.welcome_mode !== 'END' && allowToSubmitCookie"
                                class="btn btn-primary"
                                :href="computedAddUrl"
                                :title="language.give_comment"
                                ><i class="fas fa-pencil-alt"></i>
                                {{ buttonname }}
                            </a>

                        </div>

                    </div>

                </div>

                <div class="navigation-wrap">

                    <div class="boxes">

                        <slick
                            class="slider-nav"
                            ref="slickNav"
                            :options="slickNavOptions"
                            @afterChange="handleAfterChange"
                            v-on:beforeChange="handleBeforeChange"
                            v-on:init="handleInit"
                        >
                            <div
                                v-for="(slide, index) in project.items"
                                :data-slideID="slide.id"
                                :title="'Fråga ' + (index + 1)"
                                :key="`slide-${index}`"
                                class="slide-square-nav allowtab"
                                :tabindex="( (index + 1) * 2 -1 )"
                            >

                                <div :class="`slide-wrapper ${slide.type}`">

                                    <div
                                        v-if="!addopinion && slide.answer_count > 0"
                                        class="amount-items"
                                    >

                                        <span :title="'Antal svar: ' + slide.answer_count">{{ slide.answer_count }}</span>

                                    </div>

                                    <div
                                        v-if="
                                            addopinion && getSlideCount(slide) > 0
                                        "
                                        class="amount-items"
                                    >
                                        <span>{{ getSlideCount(slide) }}</span>
                                    </div>

                                    <span class="item-type">{{ index + 1 }}</span>

                                    <div
                                        class="image-type"
                                        v-if="slide.type == 'image'"
                                    >
                                        <img
                                            alt="Thumbnail"
                                            :src="`/images/projects/${ getImageSrc(slide.assets, 'thumbnail') }`"
                                        />
                                    </div>

                                    <div v-else-if="slide.type == 'question'">
                                        <div class="question-slide"></div>
                                    </div>

                                    <div class="map-type" v-else>
                                        <img
                                            alt="Thumbnail"
                                            :src="getThumbnailMapbox(slide)"
                                        />
                                    </div>

                                </div>

                            </div>

                        </slick>

                    </div>
                </div>

                <div
                    v-if="addopinion === true"
                    class="show-mobile commit-answers"
                >
                    <div class="d-flex align-items-center last-item">

                        <button
                            v-bind:class="{
                                'btn btn-thirdly mobile-button active': isActive,
                                'btn btn-thirdly mobile-button': !isActive
                            }"
                            :disabled="allowSendOpinions()"
                            @click="submitInfomation()"
                            :title="dataStore.collectedAnswers.length > 1 ? language.submit_comments : language.submit_comment"
                        >
                        <i class="fas fa-paper-plane"></i>
                        </button>
                    </div>
                </div>

                <div v-else class="settings-nav show-mobile">
                    <div class="d-flex align-items-center last-item">
                        <a
                            class="btn btn-secondary"
                            v-on:click="toggleOptionMenu()"
                            :title="language.analysis"
                            >
                            <i class="far fa-chart-bar"></i>
                        </a>
                    </div>
                </div>

                <div class="settings-nav show-desktop">
                    <div v-if="addopinion == true" class="container">
                        <div class="d-flex align-items-center">

                            <span v-if="addopinion && dataStore.collectedAnswers.length" class="collected-answers bottom">{{ dataStore.collectedAnswers.length > 1 ? language.amount_to_submit_comments.replacePlaceholders({ amount: dataStore.collectedAnswers.length}) : language.amount_to_submit_comment.replacePlaceholders({ amount: dataStore.collectedAnswers.length}) }}</span>

                            <button
                                class="btn btn-primary desktop-button flex"
                                :disabled="allowSendOpinions()"
                                @click="submitInfomation()"
                                :title="dataStore.collectedAnswers.length > 1 ? language.submit_comments : language.submit_comment"
                            >

                            <i class="fas fa-paper-plane"></i>

                                {{
                                    dataStore.collectedAnswers.length > 1
                                        ? language.submit_comments
                                        : language.submit_comment
                                }}

                            </button>
                        </div>
                    </div>
                    <div class="container" v-else>
                        <div class="d-flex align-items-center last-item">
                            <a
                                class="btn btn-secondary flex"
                                ref="optionMenu"
                                v-on:click="toggleOptionMenu()"
                                :title="language.analysis"
                                ><i class="far fa-chart-bar"></i> {{ language.analysis }}</a
                            >
                        </div>
                    </div>
                </div>
            </div>

            <image-pop-up v-if="dataStore.currentSlide && dataStore.currentSlide.type === 'image'" />

            <confirmation
                :project="project"
                :geturl="computedGetUrl"
                :addurl="computedAddUrl"
            />

            <last-part-form
                :project="project"
                :hideinputs="hideinputs"
                :newsletter="project.newsletter"
                :genders="project.genders"
                :counties="project.counties"
                :ages="project.ages"
                :types="project.types"
            />

            <welcome-window
                :project="project"
                :currentUrl="currentUrl"
                :geturl="computedGetUrl"
                :addurl="computedAddUrl"
            />

            <settings-menu
                :project="project"
                :componentKey="componentKey"
            />
            <!-- toggle mode -->
            <button
                class="btn btn-secondary"
                id="toggle-map-list"
                title="Ändra visningsvy"
                @click="toggleViewOnSlide()"
                v-if="!addopinion && dataStore.currentSlide && dataStore.currentSlide.question.type === 'goodbad'"
            >
                {{ language[nextView()] }}
            </button>

        </div>

    </fragment>

</template>

<script>

import { Fragment } from "vue-fragment"

import Slick from "vue-slick"

import VueCookies from "vue-cookies"

import dataStore from "../store"

import SettingsMenu from "./SettingsMenu"

import WelcomeWindow from "./layout/WelcomeWindow"

import ImagePopUp from "./layout/ImagePopUp.vue"

import LastPartForm from "./layout/LastPartForm"

import AnalyseSvg from "./layout/AnalyseSvg"

import Terms from "./layout/Terms"

import MainNavigation from "./layout/MainNavigation"

import Confirmation from "./layout/Confirmation"

import SkipToNext from './layout/SkipToNext'

import GoodBadSlide from "./question-types/GoodBadSlide"

import ScaleFreetextSlide from "./question-types/ScaleFreetextSlide"

import LoadingScreen from './layout/LoadingScreen'

import { nextViewName } from './../translations'

import { slickNavOptions, slickOptions } from '../settings'

import { zoomIn, zoomOut, getImageSrc } from './../image-functions'

import { getThumbnailMapbox } from './../map-functions'

import { getCurrentKey } from './../functions'

import {
    clickableTabElement,
    removeTabindex,
    eventRerenderChart,
    getSearchParameters,
    resetCurrentOpinion,
    getItem,
    toggleView,
    toggleSettingsMenu
} from './../functions'


export default {

    components: {

        Slick,

        LastPartForm,

        Confirmation,

        Terms,

        SettingsMenu,

        MainNavigation,

        WelcomeWindow,

        AnalyseSvg,

        GoodBadSlide,

        ScaleFreetextSlide,

        Fragment,

        SkipToNext,

        LoadingScreen,

        ImagePopUp

    },

    props: {

        project: Object,

        addopinion: Boolean,

        ispreview: Boolean,

        buttonname: String,

        hideinputs: Object,

        addurl: String,

        geturl: String,

        addurlpreview: String,

        geturlpreview: String,

        type: {
            type: [String],
            default: null
        }

    },

    inject: [ 'language' ],

    provide() {

        return {
            loading : this.loading
        }

    },

    computed: {

        sortedProjectItems: function() {
            return this.project.items.sort((a, b) => a.sort - b.sort)
        },

        currentUrl: function() {
            return this.addopinion ? this.addurl : this.geturl;
        },

        isActive: function() {
            return this.dataStore.collectedAnswers.length > 0 ? true : false;
        },

        getClassMobile: function() {
            return this.onResize()
        },

        computedGetUrl: function() {
            return this.ispreview ? this.geturlpreview : this.geturl
        },
        
        computedAddUrl: function() {
            return this.ispreview ? this.addurlpreview : this.addurl
        }
    },

    mounted() {

        this.dataStore.slickNavigation = this.$refs.slickNav;

        this.dataStore.project = this.project;

        this.onResize()

        this.dataStore.addopinion = this.addopinion;

        let hints = this.project.items.map(slide => ({
            showHint: true,
            id: slide.id
        }));

        sessionStorage.setItem( this.project.slug + '-hints', JSON.stringify(hints) );

        const paths = window.location.pathname.split('/');

        if(paths.includes('faq')) {
            this.dataStore.faqOpen = true
        }

        // set slider reachable globally
        this.dataStore.sliderObject = this.$refs.slick;

        window.addEventListener("resize", this.onResize, { passive: true })

        if( this.project.spam_protection ) {
            this.allowToSubmitCookie = ! VueCookies.get( 'placetoplan-project-' + this.project.id )
        }


        clickableTabElement()

    },

    data() {
        return {
            dataStore,
            componentKey: 0,
            slickOptions: slickOptions,
            slickNavOptions: slickNavOptions,
            loading : false,

            allowToSubmitCookie: true,

            getImageSrc,
            getCurrentKey,
            getThumbnailMapbox
        };
    },

    methods: {

        toggleOptionMenu: function() {
            toggleSettingsMenu();
        },

        onResize: function() {
            return window.innerWidth > 600 ? 'slider-for is-not-mobile' : 'slider-for is-mobile'
        },

        nextView: function() {
            return nextViewName();
        },

        getSlideCount: function(slide) {
            if (this.dataStore.collectedAnswers.length) {
                return this.dataStore.collectedAnswers.filter(
                    s => s.item_id === slide.id
                ).length;
            }
        },

        zoomInHandler: function(type) {
            zoomIn(type);
        },

        zoomOutHandler: function(type) {
            zoomOut(type);
        },

        drop: function(e) {
            this.dataStore.movingPin = null;
        },

        toggleViewOnSlide: function() {
            toggleView(false, this);
        },

        getPinImage: function(marker) {

            let bad = "/images/pin_forbattra", good = "/images/pin_bra", type, url = '';

            const deepLinkParam = getSearchParameters(this.project);

            marker = Array.isArray(marker) ? marker.pop() : marker;

            // check marker on marker.addOnExisting see mabye set blue default

            if (this.dataStore.viewActive.heatmap) {
                type = 'heatmap';
            }
            // mabye on marker.addOnExisting also?
            else if(deepLinkParam !== null && deepLinkParam.deeplink === marker.deep_link) {
                type = 'deeplink'
            }

            else if(marker.multi !== null && !this.addopinion) {

                type = 'multi';

                const firstAnswer = this.dataStore.collectedAnswers.filter(m => m.id === marker.firstId).pop()

                if(firstAnswer) {
                    type = firstAnswer.value_type;
                }

                if(deepLinkParam && marker.multi) {

                    const deeplinks = this.dataStore.collectedAnswers.filter(m => JSON.parse(marker.multi).includes(m.id)).map(m => m.deep_link)

                    if(deeplinks.includes(deepLinkParam)) {
                        type = 'deeplink'
                    }
                }

            } else {
                type = this.dataStore.currentOpinion.id === marker.id ? this.dataStore.currentOpinion.value_type : marker.value_type
            }

            switch (type) {
                case "multi":
                    url = "/images/pin_multi.png";
                    break;
                case "good":
                    url = good + ".png";
                    break;
                case "bad":
                    url = bad + ".png";
                    break;
                case "deeplink":
                    url = "/images/deeplink.png";
                    break;
                case "heatmap":
                    url = "/images/heatmap.png";
                    break;
                default:
                    url = good + ".png";
            }

            return url;
        },

        submitInfomation: function() {
            this.dataStore.showLastPartForm = true;
        },

        // ###Slick methods###
        next() {
            this.$refs.slick.next();
        },

        prev() {
            this.$refs.slick.prev();
        },

        // Events listeners
        handleAfterChange: async function(event, slick, currentSlide) {

            let currentItemID = slick.$slides[currentSlide].children[0].children[0].getAttribute("data-slideid")

            this.dataStore.currentSlideNumber = slick.currentSlide

            let slide = getItem(this.project.items, currentItemID)

            this.componentKey += 1;

            this.dataStore.currentSlide = slide

            VueCookies.set("slide-number", this.dataStore.currentSlideNumber)

        },

        handleBeforeChange: async function(event, slick, currentSlide, nextSlide) {

            let currentItemID = slick.$slides[nextSlide].children[0].children[0].getAttribute("data-slideid")

            let slide = getItem(this.project.items, currentItemID);

            this.dataStore.currentSlide = slide

            this.dataStore.error = false

            if ( this.addopinion === false ) {
                this.dataStore.collectedAnswers = await this.getMarkersForSlide(currentItemID)
            }

            this.componentKey += 1;

            if (this.addopinion === true) {
                this.currentOpinionBefore(slide);
            }

            if ( slide !== undefined && this.addopinion === false && (slide.type === "map" || slide.type === "image") ) {

                this.backToNormalView()

                if ( slide.type === "map" ) {

                    this.dataStore.currentMapZoom = parseFloat(slide.zoom)

                    this.dataStore.allowToAdjustMap = true;
                }

                if (slide.type === "image") {
                    $(".heatmap-canvas").remove()
                }
            }

            if ( slide.question && slide.question.type === "scale" && this.project ) {
                this.dataStore.currentOpinion.values = this.dataStore.currentOpinion.values.length === 0 ? "[]" : this.dataStore.currentOpinion.values
            }

            if ( this.dataStore.selectedFilters.length ) {
                this.dataStore.selectedFilters = []
            }

            if ( slide.question && slide.question.type === "scale" && this.project ) {
                eventRerenderChart();
            }

            this.tabControll()
        },

        handleInit: async function(event, slick) {

            this.dataStore.currentSlideNumber = slick.currentSlide;

            this.dataStore.totalSlideCount = slick.slideCount;

            if (this.dataStore.totalSlideCount === 0) {
                return;
            }

            let currentItemID = slick.$slides[slick.currentSlide].children[0].children[0].dataset.slideid;

            let slide = getItem(this.project.items, currentItemID);

            this.dataStore.currentSlide = slide

            if ( this.addopinion === false ) {
                this.dataStore.collectedAnswers = await this.getMarkersForSlide(currentItemID)
            }

            if ( (slide.type === "question" || slide.type === "video") && this.addopinion === true ) {
                this.currentOpinionBefore(slide, true);
            }

            if ( slide !== undefined && this.addopinion === false && slide.type === "map" ) {
                this.dataStore.currentMapZoom = parseFloat(slide.zoom)
            }

            if ( slide.question && slide.question.type === "scale" && this.project ) {

                this.dataStore.currentOpinion.values =
                    this.dataStore.currentOpinion.values.length === 0
                        ? "[]"
                        : this.dataStore.currentOpinion.values;
            }

        },

        allowSendOpinions: function() {
            return this.dataStore.formPopUpReady || this.dataStore.collectedAnswers.length == 0 || this.dataStore.limitOnSlideReached;
        },

        resetCurrentOpinion: function() {
            resetCurrentOpinion()
        },

        currentOpinionBefore: function(slide, showFirst = false) {

            if (slide) {

                if (this.dataStore.collectedAnswers.length > 0) {

                    let found;

                    if ( showFirst || (slide.question && (slide.question.type === "scale" || slide.question.type === "freetext") ) ) {
                        found = this.dataStore.collectedAnswers.find(
                            el => el.item_id == slide.id
                        );
                    }

                    if (found !== undefined) {
                        this.dataStore.currentOpinion = found;
                    }

                    else {
                        this.resetCurrentOpinion();
                    }
                }

                else {
                    this.resetCurrentOpinion();
                }
            }
        },

        tabControll: function() {

            removeTabindex()

            // need to add index too all items with allowtab-subitem class
            const currentIndex = document.querySelector('.slick-current.slick-active').dataset.slickIndex

            document.querySelectorAll('.slick-current.slick-active .allowtab-subitem').forEach(subEl => {
                subEl.setAttribute('tabindex', (parseFloat(currentIndex) + 1 ) * 2 )
            })

        },

        /**
         * Description: If to allow show hint on the item currently at
         * @return {Boolean}
         */
        allowHint: function(slug, slideID) {

            let hints = JSON.parse( sessionStorage.getItem(slug + '-hints') );

            if (!hints) return;

            let hint = hints.find(slide => slide.id === slideID);

            if (hint) {
                return hint.showHint;
            }

            return;
        },

        /**
         * Description: Resets heatmap to normal view
         * @return {Void}
         */
        backToNormalView: function() {

            this.dataStore.activeViewIndex = 0

            this.dataStore.viewActive = {
                normal: true,
                heatmap: false,
                listing: false
            }
            
        },

        getMarkersForSlide: async function( slideID, deepLink = null ) {

            this.dataStore.collectedAnswers = []

            this.loading = true

            if( ! this.addopinion ) {

                const result = await axios.post(`/api/answers`, { project_slug : this.project.slug, item_id : slideID, deeplink : deepLink })

                try {

                    this.loading = false

                    if( this.dataStore.currentSlide.type === 'map' ) {
                        this.$emit('loaded')
                    }

                    return result.data

                } catch (error) {

                    console.log(error)

                    return []

                }

            }

            return []

        }

    }

};
</script>
